import { observable, makeObservable, action, computed, flow } from "mobx";
import { v4 } from "uuid";
import moment from "moment";
import ChatManager from "../chat/manager";
import { ResCode } from "../../constants/request";
import * as richModalChatService from "../../services/richmodal";
import SessionFileManager from "./sessionFileManager";
import { ESessionStatus } from "./type";
import { ISessionFile } from "./type";
import * as richmodalService from "../../services/richmodal";
import { generateTitle } from "../../services/videoEdit";
import {
  EChatModel,
  ESendMsgType,
  EStreamDataType,
  IChatMessage,
} from "../chat/types";
import Chat from "../chat/model";

// 继承Chatmanager
class Session extends ChatManager {
  time: string;
  @observable tempId: string = v4();
  // @observable id: string;
  @observable name: string;
  @observable status: ESessionStatus;
  @observable.ref fileManager: SessionFileManager | null = null;

  @observable is_top?: boolean;
  @observable is_deleted?: boolean;
  file_list?: ISessionFile[];
  @observable total_token: number;

  @observable.ref firstMessage: IChatMessage | Chat | null = null;

  @computed
  get title() {
    if (this.name) {
      return this.name;
    } else if (this.chatInstanceList.length > 0) {
      return this.chatInstanceList[0].initialSessionTitle;
    } else {
      return "新会话";
    }
  }

  public constructor(id: string) {
    super(id);
    makeObservable(this);
    // this.id = id;
    this.name = "";
    this.total_token = 0;
    this.is_top = false;
    this.is_deleted = false;
    this.file_list = undefined;
    this.fileManager = null;
    this.status = ESessionStatus.work;
    this.total_token = 0;
    this.getSessionInfo = this.getSessionInfo.bind(this);
    this.instantiateChatList = this.instantiateChatList.bind(this);
    this.getSessionFullInfo = this.getSessionFullInfo.bind(this);
    this.editName = this.editName.bind(this);
    this.time = moment().format("YYYY-MM-DD HH:mm:ss");
    if (!this.session_id) {
      this.instantiateFileManager();
    }
  }

  @action.bound
  setStatus(v: ESessionStatus) {
    this.status = v;
  }

  @action.bound
  setFirstMessage(v: IChatMessage | Chat | null) {
    this.firstMessage = v;
  }

  @flow
  public *getSessionInfo() {
    if (!this.session_id) return;
    const {
      message: { status, file_list, title, is_top, is_deleted, total_token },
    } = yield richmodalService.getSessionInfo({
      session_id: this.session_id,
    });
    this.status = status;
    this.name = title;
    this.is_top = is_top;
    this.is_deleted = is_deleted;
    this.total_token = total_token;
    this.file_list = file_list;
  }

  @flow
  *instantiateFileManager() {
    this.fileManager = new SessionFileManager(this.file_list);
  }

  @flow
  public *instantiateChatList() {
    yield this.getChatInstanceList();
  }

  @action.bound
  async handleStreamEnd(v: Chat) {
    console.log("handleStreamEnd--22", v);
    const firstMessage = this.chatInstanceList[0];
    if (!this.name && firstMessage?.chatModel === EChatModel.Video) {
      const res = await this.editNameByChat(v);
    }
  }

  public async getFirstMessage() {
    const { code, message } = await richModalChatService.getFirstMessage({
      session_id: this.session_id,
      page_size: 1,
      next: "",
    });
    const resList = code === ResCode.Success ? message : [];
    if (resList.length > 0) {
      this.setFirstMessage(resList[0]);
    }
  }

  @flow
  public *getSessionFullInfo(skipParseFile: boolean = false) {
    yield this.getSessionInfo();
    if (!skipParseFile) {
      yield this.instantiateFileManager();
    }
    yield this.instantiateChatList();
    // yield Promise.all([
    //   this.getSessionInfo(),
    //   this.instantiateFileManager(),
    //   this.instantiateChatList(),
    // ]);
    // const {
    //   message: { status },
    // } = await richmodalService.getSessionInfo({
    //   session_id: id,
    // });
    // this.status = status;
  }

  public async editName(name: string) {
    await richmodalService.editSessionTitle({
      session_id: this.session_id,
      title: name,
    });
    this.name = name;
  }

  public async editNameByChat(chat: Chat) {
    const text = chat.allTextStr;
    const res = await generateTitle(text);
    if (res && res.code === 0) {
      let name = res.message.title;
      if (name.startsWith("标题：")) {
        name = name.slice(3);
      }
      await this.editName(name);
      return this.name;
    }
  }

  @flow.bound
  *deleteSessionFile(file_id: string) {
    yield richmodalService.deleteFile(file_id);
    yield this.getSessionInfo();
    yield this.instantiateFileManager();
  }

  @action.bound
  async createQAChat(sendMsg: string, recvMsg: string) {
    if (this.isCreatingQA) return false;
    const params = {
      parent_id: "0",
      send_msg: [
        {
          msg_type: ESendMsgType.user_query,
          user_query: sendMsg,
        },
      ],
      recv_msg: [
        {
          text: recvMsg,
          text2image: "",
          type: EStreamDataType.text,
          web_searcher: [],
        },
      ],
    };
    const result = await this.getInfoAfterCreateQA(params);
    if (result && result.session_id && result.message_id) {
      // 设置session info
      this.setSessionId(result.session_id);
      this.setStatus(ESessionStatus.work);
      // 设置chatManager中 session info
      this.setSessionId(result.session_id);
      this.setSessionStatus(ESessionStatus.work);
      // 保存chat实例
      this.addQAChat(result.message_id, params.send_msg, params.recv_msg);
      return true;
    }
    return false;
  }
}

export default Session;
